/**!
 * Created by Leonardo Cheslacki on 13/03/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import HelpersController from './HelpersController';

import PropTypes from 'prop-types';

import WithType from './WithType';

let _this = {};

/**
 *
 */
class HelpersSpinner extends HelpersController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {};

        this.$button = null;
        this.$content = null;

        _this = this;
    };

    removeElementSpinner = () => {
        const
            {document, className, classNames} = this.props,
            helpersElement = AllTap.$helpersElement({document: document});

        if (this.isElement(this.$button) && !this.isEmpty(this.$content)) {
            this.$button.innerHTML = this.$button.innerText = this.$content;
            this.$button.removeAttributeNode(this.$button.getAttributeNode('disabled'));
            this.$button = this.$content = null;
            this.recursiveSyncMap(classNames, 0, classNames.length, (item, next) => {
                if (className !== item) {
                    let element = helpersElement.getByClass(item);

                    element.removeAttributeNode(element.getAttributeNode('disabled'));
                }

                next(true);
            });
        }
    };

    appendElementSpinner = () => {
        const
            {document, className} = this.props,
            helpersElement = AllTap.$helpersElement({document: document}),
            helpersClass = AllTap.$helpersClass({document: document});

        let element = helpersElement.getByClass(className);

        if (this.isElement(this.$button) && this.isEmpty(this.$content) && this.isElement(element)) {

            this.$content = (element.innerHTML || element.innerText);

            element.innerHTML = element.innerText = '';

            let span = document.createElement('span');

            helpersClass.addClasses(span, 'spinner-grow', 'spinner-grow-sm');

            this.$button.setAttributeNode(document.createAttribute('disabled'));
            this.$button.appendChild(span);
        }
    };

    start = () => {
        const
            {document, className, classNames} = this.props,
            helpersElement = AllTap.$helpersElement({document: document});

        let button = helpersElement.getByClass(className);

        if (this.isElement(button)) {

            this.$button = button;

            this.appendElementSpinner();

            this.recursiveSyncMap(classNames, 0, classNames.length, (item, next) => {

                if (className !== item) {
                    let element = helpersElement.getByClass(item);

                    element.setAttributeNode(document.createAttribute('disabled'));
                }

                next(true);
            });
        }
    };

    stop = () => {
        this.throttle('helpers-spinner', () => {
            this.removeElementSpinner();
        }, 1000);
    };
}

/**
 *
 * @type {{}}
 */
HelpersSpinner.propTypes = {
    document: PropTypes.object,
    className: PropTypes.oneOf(['button-submit']),
    classNames: PropTypes.array
};

/**
 *
 * @type {{}}
 */
HelpersSpinner.defaultProps = {
    document: {},
    className: 'button-submit',
    classNames: [
        'button-submit',
        'button-default'
    ]
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(HelpersSpinner, {className: 'HelpersSpinner'});
